<template>
  <div class="bg-primary">
    <footer class="relative bg-blueGray-200 pt-8 pb-6">
      <div class="container mx-auto px-4">
        <div class="flex flex-wrap text-left lg:text-left">
          <div class="w-full lg:w-6/12 px-4">
            <h4 class="text-3xl fonat-semibold text-blueGray-700">ກົມເຕັກໂນໂລຊີດີຈີຕອນ</h4>
            <h5 class="text-lg mt-0 mb-2 text-blueGray-600">
              ລະບົບຄຸ້ມຄອງການອອກອະນຸຍາດດ້ານເຕັກໂນໂລຊີດີຈີຕອນ <br> ພັດທະນາຮ່ວມກັບ <br> <a href="https://www.sitclao.com" target="_blank" style="color: white;">ບໍລິສັດ ໄຊຍະສິດ ໄອທີ ທີ່ປຶກສາ ຈໍາກັດ ຜູ້ດຽວ</a>
            </h5>
            <div class="mt-6 lg:mb-0 mb-6">
              <button
                class="bg-white text-lightBlue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                type="button">
                <i class="fab fa-twitter"></i></button><button
                class="bg-white text-lightBlue-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                type="button">
                <i class="fab fa-facebook-square"></i></button><button
                class="bg-white text-pink-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                type="button">
                <i class="fab fa-dribbble"></i></button><button
                class="bg-white text-blueGray-800 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                type="button">
                <i class="fab fa-github"></i>
              </button>
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="flex flex-wrap items-top mb-6">
              <div class="w-full lg:w-4/12 px-4 ml-auto">
                <span class="block uppercase text-blueGray-500 text-sm font-semibold mb-6"></span>
                <ul class="list-unstyled">
                  <!-- <li>
                    <a class="text-white hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="/#/about">ກ່ຽວກັບພວກເຮົາ</a>
                  </li> -->
                  <li>
                    <a class="text-white hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="/#/contact">ຕິດຕໍ່ພົວພັນ</a>
                  </li>
                  <li>
                    <a class="text-white hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="/#/search">ຄົ້ນຫາໃບອະນຸຍາດ</a>
                  </li>
                  <li>
                    <a class="text-white hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="/#/attachments">ເອກະສານທີ່ກ່ຽວຂ້ອງ</a>
                  </li>
                </ul>
              </div>
              <!-- <div class="w-full lg:w-5/12 px-4">
                <span class="block uppercase text-blueGray-500 text-sm font-semibold mb-2">Other Resources</span>
                <ul class="list-unstyled">
                  <li>
                    <a class="text-white hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="https://github.com/creativetimofficial/notus-js/blob/main/LICENSE.md?ref=njs-profile">MIT
                      License</a>
                  </li>
                  <li>
                    <a class="text-white hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="https://creative-tim.com/terms?ref=njs-profile">Terms &amp; Conditions</a>
                  </li>
                  <li>
                    <a class="text-white hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="https://creative-tim.com/privacy?ref=njs-profile">Privacy Policy</a>
                  </li>
                  <li>
                    <a class="text-white hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                      href="https://creative-tim.com/contact-us?ref=njs-profile">Contact Us</a>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
        <hr class="my-6 border-blueGray-300">
        <div class="flex flex-wrap items-center md:justify-between justify-center">
          <div class="w-full sm:w-12/12 xs:w-12/12 md:w-12/12 px-4 mx-auto text-center">
            <p class="f-color ma-0">
              <strong>
                © {{ new Date().getFullYear() }}. DDT, Ministry of Technology and Communication. Powered by <a href="https://www.sitclao.com" target="_blank" style="color: white;">SITC Lao</a>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>


  <!-- <v-footer class="bg-primary ext-center d-flex flex-column">

    <div>
      <v-btn v-for="icon in icons" :key="icon" class="mx-4" :icon="icon" variant="text"></v-btn>
    </div>
    <v-row align="center" justify="center">

      <h2 class="ma-2 mt-4">ກົມເຕັກໂນໂລຊີດີຈີຕອນ</h2>
    </v-row>
    <v-row align="center" justify="center">
      <h2 class="ma-2 mb-6">Department of Digital Technology</h2>
    </v-row>
    <v-row class="ma-2" justify="center">
      <v-col class="ml-3">
        <v-row class="mb-2 text-white" justify="center">
          <p>ລະບົບຄຸ້ມຄອງການອອກອະນຸຍາດດ້ານເຕັກໂນ</p>
        </v-row>
        <v-row class="mb-2 text-white" justify="center">
          <p>ໂລຊີດີຈີຕອນ ພັດທະນາຮ່ວມກັບ ບໍລິສັດ</p>
        </v-row>
        <v-row class="text-whiter" justify="center">
          <p>ໄຊຍະສິດ ທີ່ປຶກສາ ໄອທີ ຈໍາກັດ ຜູ້ດຽວ</p>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="bg-primary">
      <p class="f-color ma-4">
        <strong>
          © {{ new Date().getFullYear() }}. DDT, Ministry of Technology and Communication. Powered by SITC Lao
        </strong>
      </p>
    </v-row>
  </v-footer> -->
</template>

<script>
export default {
  data: () => ({
    icons: [
      'mdi-facebook',
      'mdi-twitter',
      'mdi-linkedin',
      'mdi-instagram',
    ],
  }),
};
</script>

<style scoped>
.bg-color {
  background-color: #0a2640;
}

h1 {
  color: white;
}

.btn-1 {
  font-weight: bold;
  width: 200px;
}

.btn-2 {
  font-weight: bold;
  background-color: #65e4a3;
}

.f-weight {
  font-weight: bold;
}

@import 'src/assets/css/font-awesome/all.min.css';
</style>
